<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte'
  import type { IntlString } from '@hcengineering/platform'
  import ui from '../../plugin'
  import Label from '../Label.svelte'
  import RootBarExtension from './RootBarExtension.svelte'
  import Clock from './Clock.svelte'
  import Settings from './Settings.svelte'
  import IconClose from '../icons/Close.svelte'
  export let label: IntlString
  const dispatch = createEventDispatcher()
  let panel: HTMLDivElement
  let closeButton: HTMLButtonElement
  onMount(() => {
    const previousFocus = document.activeElement
    closeButton.focus()
    return () => {
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected &&
        (panel.contains(document.activeElement) || document.activeElement === document.body)) previousFocus.focus()
    }
  })
  function handleKeydown (event: KeyboardEvent): void {
    if (event.key !== 'Tab') return
    const controls = Array.from(panel.querySelectorAll<HTMLElement>('a[href], button:not(:disabled), [tabindex="0"]'))
      .filter((element) => element.getClientRects().length > 0)
    const edge = event.shiftKey ? controls[0] : controls[controls.length - 1]
    if (document.activeElement === edge) {
      event.preventDefault()
      ;(event.shiftKey ? controls[controls.length - 1] : controls[0])?.focus()
    }
  }
</script>

<!-- svelte-ignore a11y-no-noninteractive-element-interactions -->
<div
  class="antiPopup workbench-tools"
  bind:this={panel}
  role="dialog"
  aria-modal="true"
  aria-labelledby="workbench-tools-title"
  tabindex="-1"
  on:keydown={handleKeydown}
>
  <header>
    <strong id="workbench-tools-title"><Label {label} /></strong><button
      type="button"
      bind:this={closeButton}
      on:click={() => dispatch('close')}
      ><IconClose size="small" /><span class="sr-only"><Label label={ui.string.Cancel} /></span></button
    >
  </header>
  <div class="extensions"><RootBarExtension position="left" /></div>
  <div class="extensions"><RootBarExtension position="right" /></div>
  <footer><Clock /><Settings /></footer>
</div>

<style lang="scss">
  .workbench-tools {
    box-sizing: border-box;
    width: min(28rem, calc(100vw - 1rem));
    max-height: calc(100dvh - 2rem);
    overflow: auto;
    padding: 0.75rem;
  }
  header,
  footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
  }
  button {
    min-width: 44px;
    min-height: 44px;
    color: inherit;
    background: transparent;
    border: 0;
    cursor: pointer;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }
  .extensions {
    min-width: 0;
    overflow-x: auto;
    padding: 0.75rem 0;
  }
</style>
